/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { ICustomTheme } from 'interfaces';
import { Title } from 'components';

const Wrapper = styled.div<{ theme: ICustomTheme }>(({ theme }) => ({
  flex: '1 0 auto',
  padding: theme.spacing(5),
}));

const NotFound = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Title textCase="sentence">{t('core.page_not_found')}</Title>
    </Wrapper>
  );
};

export default NotFound;
